"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative min-h-screen grid lg:grid-cols-2 items-stretch">
      {}
      <div ref={leftRef} className="relative z-10 flex flex-col justify-center px-6 py-16 lg:px-12 xl:px-16 bg-light-background">
        <div className="max-w-2xl mx-auto lg:mx-0 space-y-6">
          <h1 className={`font-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-light leading-tight ${leftVisible ? "animate-fade-in-up" : "opacity-0"}`}>
            Empowering Special Needs Students with Technology & AI
          </h1>

          <p className={`text-lg md:text-xl text-muted-foreground leading-relaxed ${leftVisible ? "animate-fade-in-up-delay-100" : "opacity-0"}`}>
            Mobile and virtual special education services for K‑12 learners, delivering personalized instruction in ELA, science, social studies, and behavioral support.
          </p>

          <div className={`pt-4 ${leftVisible ? "animate-fade-in-up-delay-200" : "opacity-0"}`}>
            <Link to="#">
              <Button size="lg" className="bg-action text-foreground-action hover:bg-action-hover active:bg-action-dark shadow-medium hover:scale-[1.02] transition-transform duration-[var(--duration-fast)] ease-[var(--ease-spring)]">
                Explore Our Services
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="relative min-h-[400px] lg:min-h-screen overflow-hidden">
        {}
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1465435/img/special_education_technology_classroom.png)] transition-transform duration-[var(--duration-slow)] ease-linear" style={{
        transform: typeof window !== "undefined" ? `translateY(${window.scrollY * 0.3}px)` : "translateY(0)"
      }} />
        {}
        <div className="absolute inset-0 surface-overlay flex items-end p-8 lg:p-12">
          <div className="glass-effect p-6 lg:p-8 max-w-md">
            <p className="text-foreground-primary text-base lg:text-lg leading-relaxed">
              Leveraging advanced AI‑driven assessment tools and experienced special education professionals to create accessible, inclusive learning environments for diverse learners.
            </p>
          </div>
        </div>
      </div>
    </section>;
}